'use strict';

var _ = require('lodash');
var AdvancedHepPayloadService = function AdvancedHepPayloadService(advancedHepTransformationService, momentConstants, momentService, configurationParametersAdvancedService) {
  var dateTypeAttrs = [{
    name: 'legDepartureDateBegin',
    momentConfig: momentService.FIELD.ND_DEPARTURE_DATE
  }, {
    name: 'legDepartureDateEnd',
    momentConfig: momentService.FIELD.ND_DEPARTURE_DATE
  }, {
    name: 'runDateBegin',
    momentConfig: momentService.FIELD.OPTIMIZATION_RUN_DATE
  }, {
    name: 'runDateEnd',
    momentConfig: momentService.FIELD.OPTIMIZATION_RUN_DATE
  }, {
    name: 'travelDateBegin',
    momentConfig: momentService.FIELD.TRAVEL_DATE
  }, {
    name: 'travelDateEnd',
    momentConfig: momentService.FIELD.TRAVEL_DATE
  }];
  var defaultAttributeValues = [{
    name: 'runDate',
    value: 'runDate'
  }, {
    name: 'travelDate',
    value: 'travelDate'
  }];
  var propertyValuesMapping = {
    'Distribute slack to the classes in proportion to class protections': 'PROTECTION',
    'No slack distribution': 'NO_DISTRIBUTION',
    'Distribute slack to top class': 'TOP',
    'Distribute slack to the top 3 open classes': 'TOP3OPEN',
    'Distribute slack to the classes in proportion to class remaining demand': 'REMAINING_DEMAND',
    'Distribute slack to the classes in proportion to class CER': 'CER',
    'Distribute slack to the bottom 3 open classes': 'BOTTOM3OPEN',
    'Backward Curve Floor': 'BP_BACKWARD_CURVE_FLOOR',
    'Entire Curve Floor': 'BP_FLOOR',
    'No Flooring': 'NO_CAPPING',
    'Round Trip': 'ROUNDTRIP',
    'One-Way': 'ONEWAY'
  };
  function isBoolean(value) {
    return value === 'Yes' || value === 'No';
  }
  function correctValueForSaving(row, key, type, level) {
    if (key === 'legId') {
      return createLegId(row);
    }
    if (isBoolean(row[key])) {
      return row[key] === 'Yes';
    }
    var defaultValue = _.find(defaultAttributeValues, {
      name: key
    });
    if (row[key] === undefined && defaultValue) {
      return defaultValue.value;
    }
    if (propertyValuesMapping[row[key]]) {
      row[key] = propertyValuesMapping[row[key]];
    }
    return row[key];
  }
  function correctValueForDeleting(row, key) {
    if (key === 'legId') {
      return createLegId(row);
    }
    if (key === 'legDepartureDateBegin' || key === 'legDepartureDateEnd') {
      return row[key].format(momentConstants.FORMATS.DATE_ISO);
    }
    if (propertyValuesMapping[row[key]]) {
      row[key] = propertyValuesMapping[row[key]];
    }
    return row[key];
  }
  function formatPropertiesWithDTD(object, method) {
    if (method) {
      object[method] = propertyValuesMapping[object[method]];
    }
    object.readingTimeInterval = object.readingTimeIntervalStart + 'd 0h 0m';
    delete object.readingTimeIntervalStart;
    delete object.readingTimeIntervalEnd;
    return object;
  }
  function formatProperties(properties, type) {
    properties = _.forOwn(properties, function (propertyValue, propertyName) {
      if (propertyName === 'daysOffsets' || propertyName === 'readingDays') {
        properties[propertyName] = _.chain(propertyValue).split(',').map(_.toInteger).value();
      }
    });
    switch (type) {
      case 'RTP':
        properties.readingDays = _.map(properties.readingDays, function (day) {
          return {
            'days': day,
            'hours': 0
          };
        });
        break;
      case 'MaxDepartureTimeWindow':
        properties.maxDepartureTimeWindow = '0d ' + properties.maxDepartureTimeWindow;
        break;
      case 'BidPriceCurveConfig':
        _.map(properties.bidPriceCurveParams, function (o) {
          return formatPropertiesWithDTD(o, 'bidPriceCappingMethod');
        });
        break;
      case 'SlackDistributionMethodEMSRConfig':
        _.map(properties.slackDistributionMethodEMSRParams, function (o) {
          return formatPropertiesWithDTD(o, 'method');
        });
        break;
      case 'OverBookingConfig':
        _.map(properties.overBookingParams, function (o) {
          return formatPropertiesWithDTD(o);
        });
    }
    return properties;
  }
  function createLegId(row) {
    var legIdData = _.pick(row, getLegIdAttributes());
    var date = legIdData.departureDate.format('YYYY-MM-DD');
    return legIdData.origin + '.' + legIdData.airlineCode + '.' + legIdData.flightNumber + '[' + date + '].' + legIdData.destination;
  }
  function createAttributes(row, type, level) {
    var attributes = {};
    if (level !== 'default') {
      _.forEach(level.split('.'), function (key) {
        attributes[key] = correctValueForSaving(row, key, type, level);
      });
    }
    var config = _.find(configurationParametersAdvancedService.getConfigs(), {
      type: type,
      level: level
    });
    _.each(config.attributes, function (attribute) {
      if (attribute.columnvalues) {
        attributes[attribute.field] = correctValueForSaving(row, attribute.columnvalues);
        delete row[attribute.columnvalues];
      }
    });
    return attributes;
  }
  function getAttributesForLevel(level) {
    var attributes = level.split('.');
    return _.includes(level, 'legId') ? _.concat(getLegIdAttributes(), _.without(attributes, 'legId')) : attributes;
  }
  function removeAttributesFromRowObject(row, level) {
    return _.pickBy(row, function (value, key) {
      return getAttributesForLevel(level).indexOf(key) === -1 && key !== 'type' && key !== 'hepKey';
    });
  }
  function cleanRow(row) {
    delete row.isNewlyAdded;
    delete row.isRowEditable;
    delete row.originalRowId;
    delete row._old;
    delete row._original;
    delete row.lastUpdatedAt;
    delete row.lastUpdatedBy;
    delete row.hepType;
  }
  function cleanEmptyFields(row) {
    _.each(row, function (property, fieldName) {
      if (_.isString(property) && _.isEmpty(property) || _.isNil(property)) {
        delete row[fieldName];
      }
    });
  }
  function cleanNestedProperties(row) {
    _.forEach(row, function (value) {
      if (_.isArray(value)) {
        _.forEach(value, function (nestedRow) {
          cleanRow(nestedRow);
        });
      }
    });
  }
  function clearAllNestedRows(rows) {
    _.forEach(rows, function (row) {
      cleanRow(row);
      cleanNestedProperties(row);
    });
  }
  function createProperties(row, type, level) {
    cleanRow(row);
    cleanNestedProperties(row);
    var properties = {};
    var propertiesFromRow = removeAttributesFromRowObject(row, level);
    var propertyValue = _.chain(propertiesFromRow).keys().head().value();
    var isNestedProperty = propertyValue !== undefined ? propertyValue.split('_').length > 1 : false;
    if (isNestedProperty) {
      var propKey = _.chain(propertiesFromRow).keys().head().value().split('_')[0];
      properties[propKey] = _.transform(_.keys(propertiesFromRow), function (result, property) {
        var propValue = property.split('_')[1];
        result[propValue] = correctValueForSaving(propertiesFromRow, property);
        return result;
      }, {});
    } else {
      properties = formatProperties(propertiesFromRow, type);
    }
    return properties;
  }
  function buildPayload(row, type, level) {
    return {
      type: type,
      attributes: createAttributes(row, type, level),
      properties: createProperties(row, type, level)
    };
  }
  function buildPayloadWithRangeOpsAttributes(row, type, level) {
    var rangeOpsAttributes = {};
    for (var dateTypeAttr in dateTypeAttrs) {
      var dateTypeAttribute = dateTypeAttrs[dateTypeAttr];
      if (row.hasOwnProperty(dateTypeAttribute.name)) {
        var fieldName = dateTypeAttribute.name;
        var momentConfig = dateTypeAttribute.momentConfig;
        rangeOpsAttributes[fieldName] = row[fieldName].value;
        row[fieldName] = row[fieldName].format(momentConfig.format);
      }
    }
    if (row.flightNumberBegin && row.flightNumberEnd) {
      rangeOpsAttributes.flightNumberBegin = row.flightNumberBegin;
      rangeOpsAttributes.flightNumberEnd = row.flightNumberEnd;
    }
    var payload = buildPayload(row, type, level);
    if (!_.isEmpty(rangeOpsAttributes)) {
      payload.rangeOpsAttributes = rangeOpsAttributes;
    }
    return payload;
  }
  function buildPayloadWithListOpsAttributes(row, type, level) {
    var listOpsAttributes;
    if (row.dayOfWeek) {
      listOpsAttributes = {};
      listOpsAttributes.dayOfWeek = row.dayOfWeek;
    }
    var payload = buildPayload(row, type, level);
    if (listOpsAttributes) {
      payload.listOpsAttributes = listOpsAttributes;
    }
    return payload;
  }
  function removeCarrierFromProperties(rows, propertiesName) {
    _.forEach(rows, function (row) {
      _.forEach(row[propertiesName], function (paramsRow) {
        delete paramsRow.carrier;
      });
    });
  }
  function buildTacticalFbcPatternProperties(row) {
    var fareBrandLevelProperty = {};
    fareBrandLevelProperty.propertyValue = row.propValue;
    fareBrandLevelProperty.tacticalFbcPatterns = row.tacticalFbcPatterns;
    return fareBrandLevelProperty;
  }
  function buildTacticalFBCPatternPayload(rows, level, type) {
    var modifiedRows = [];
    var consolidatedRows = [];
    _.forEach(rows, function (row) {
      var hepKey = buildHepKey(row, type, level);
      var rowData = _.isUndefined(modifiedRows[hepKey]) ? _.cloneDeep(row) : modifiedRows[hepKey];
      var tacticalFbcPatternProperties = buildTacticalFbcPatternProperties(row);
      rowData.tacticalFbcPatternProperties = _.isUndefined(rowData.tacticalFbcPatternProperties) ? [tacticalFbcPatternProperties] : _.concat(rowData.tacticalFbcPatternProperties, tacticalFbcPatternProperties);
      modifiedRows[hepKey] = rowData;
    });
    for (var key in modifiedRows) {
      var rowData = modifiedRows[key];
      consolidatedRows = _.concat(consolidatedRows, [rowData]);
    }
    return consolidatedRows;
  }
  function removeEmptyCarrier(row) {
    if (row.hostCarrier === '' || row.hostCarrier === null) {
      delete row.hostCarrier;
    }
  }
  function buildSavePayloads(rows, type, level) {
    if (type === 'FlightExclusion') {
      _.forEach(rows, cleanRow);
      var rowsA = _.map(rows, function (row) {
        return removeAttributesFromRowObject(row, level);
      });
      return {
        updatePayloads: [{
          type: type,
          properties: {
            'flightExclusionRanges': rowsA
          }
        }],
        deletePayloads: []
      };
    }
    if (type === 'DA_FareBrandDefinition') {
      removeCarrierFromProperties(rows, 'fareBrandDefinitionParams');
    }
    if (type === 'DA_FareBrandAssignment') {
      removeCarrierFromProperties(rows, 'fareBrandAssignmentParams');
    }
    if (type === 'DA_FareBrandNormalization') {
      removeCarrierFromProperties(rows, 'fareBrandNormalizationParams');
    }
    if (type === 'FOMarketList') {
      _.forEach(rows, cleanRow);
      _.forEach(rows, function (row) {
        row.benchmarkCarrier = row.benchmarkCarrier.toUpperCase().replace(/^\s*|\s*$/g, '').split(/\s*,\s*/);
        row.origin = row.originAirport.toUpperCase();
        row.destination = row.destinationAirport.toUpperCase();
        row.pos = row.foPos;
        row.approvedMarket = _.isNil(row.approvedMarket) ? false : row.approvedMarket;
        row.checkEntryLevelFareChange = _.isNil(row.checkEntryLevelFareChange) ? false : row.checkEntryLevelFareChange;
        row.cabinCode = row.foCabin;
        row.category = row.marketListCategory;
        delete row.originAirport;
        delete row.destinationAirport;
        delete row.foPos;
        delete row.foCabin;
        delete row.marketListCategory;
      });
      var rowsWithFilteredAttributes = _.map(rows, function (row) {
        return removeAttributesFromRowObject(row, level);
      });
      return {
        updatePayloads: [{
          type: type,
          properties: {
            'foMarkets': rowsWithFilteredAttributes
          }
        }],
        deletePayloads: []
      };
    }
    if (type === 'FOFareBrandDefinitionConfig') {
      return buildFareBrandDefinitionConfigPayload(rows, level, type);
    }
    if (type === 'FOTacticalUserOverrides') {
      rows = consolidateRowsWithSameHepKey(rows, level, type);
    }
    if (type === 'FOTacticalFBCPatternConfig') {
      rows = buildTacticalFBCPatternPayload(rows, level, type);
    }
    return _.reduce(rows, function (result, row) {
      removeEmptyCarrier(row);
      switch (type) {
        case 'FP_MarketConfig':
          var marketConfig = advancedHepTransformationService.transformFpMarketConfigPayload(row, false);
          result.updatePayloads.push(buildPayload(marketConfig.marketConfigRow, type, level));
          result.updatePayloads = _.concat(result.updatePayloads, marketConfig.modifyBenchmarkCarriers);
          result.deletePayloads = _.concat(result.deletePayloads, marketConfig.deleteBenchmarkCarriers);
          break;
        case 'FP_TOD_HubBank':
          var todBanksConfig = advancedHepTransformationService.transformFpTodHubBankConfigPayload(row);
          result.updatePayloads.push(buildPayload(todBanksConfig, type, level));
          break;
        case 'FP_MetroMarket':
          var metroMarket = advancedHepTransformationService.transformFpMetroMarketPayload(row);
          result.updatePayloads.push(buildPayload(metroMarket, type, level));
          break;
        case 'CurtainRule':
          var curtainRule = advancedHepTransformationService.transformCurtainRulePayload(row);
          result.updatePayloads.push(buildPayload(curtainRule, type, level));
          break;
        case 'FP_PricePositionStrategy':
        case 'FlightCategory':
        case 'CabinCapacityRestriction':
        case 'DA_BookingVelocityPPSAdjustment':
          result.updatePayloads.push(buildPayloadWithRangeOpsAttributes(row, type, level));
          break;
        case 'FlightCurtainRuleId':
          result.updatePayloads.push(buildPayloadWithListOpsAttributes(row, type, level));
          break;
        case 'FOBusinessRules':
          var businessRules = advancedHepTransformationService.transformFOBusinessRulesPayload(row);
          result.updatePayloads.push(buildPayload(businessRules, type, level));
          break;
        case 'FOMinStayGrouping':
          var minStayGrouping = advancedHepTransformationService.convertFOAttributeNameToAttributeName(row, 'foMinStayGroupingProperties');
          result.updatePayloads.push(buildPayload(minStayGrouping, type, level));
          break;
        case 'FOMaxStayGrouping':
          var maxStayGrouping = advancedHepTransformationService.convertFOAttributeNameToAttributeName(row, 'foMaxStayGroupingProperties');
          result.updatePayloads.push(buildPayload(maxStayGrouping, type, level));
          break;
        case 'FOAdvancePurchaseGrouping':
          var advancePurchaseGrouping = advancedHepTransformationService.transformFOAdvancePurchaseGroupingPayload(row);
          result.updatePayloads.push(buildPayload(advancePurchaseGrouping, type, level));
          break;
        case 'FOViaPoints':
          var viaPoints = advancedHepTransformationService.transformFOViaPointsPayload(row);
          result.updatePayloads.push(buildPayload(viaPoints, type, level));
          break;
        case 'FOCabinClassConfig':
          var cabinClassConfig = advancedHepTransformationService.transformFOCabinClassConfigPayload(row, 'cabinClassConfigPropertiesList');
          result.updatePayloads.push(buildPayload(cabinClassConfig, type, level));
          break;
        case 'FOTaxOverride':
          var taxOverride = advancedHepTransformationService.convertFOAttributeNameToAttributeName(row, 'taxOverridePropertiesList');
          result.updatePayloads.push(buildPayload(taxOverride, type, level));
          break;
        case 'FONoticePeriod':
          var noticePeriod = advancedHepTransformationService.transformFONoticePeriodPayload(row);
          result.updatePayloads.push(buildPayload(noticePeriod, type, level));
          break;
        case 'FOInputDataComparisonChecks':
          var inputDataComparisonChecks = advancedHepTransformationService.transformFOInputDataComparisonChecksPayload(row);
          result.updatePayloads.push(buildPayload(inputDataComparisonChecks, type, level));
          break;
        case 'FOSeasonLevelMatchThreshold':
          var seasonThreshold = advancedHepTransformationService.convertFOAttributeNameToAttributeName(row);
          result.updatePayloads.push(buildPayload(seasonThreshold, type, level));
          break;
        case 'FOUpSellBuyDownConfig':
          var upsellBuydownConfig = advancedHepTransformationService.transformFOUpSellBuyDownConfigPayload(row);
          result.updatePayloads.push(buildPayload(upsellBuydownConfig, type, level));
          break;
        case 'FORBDLevelFareThreshold':
          var rbdLevelFareThreshold = advancedHepTransformationService.transformFORbdLevelFareThresholdPayload(row);
          result.updatePayloads.push(buildPayload(rbdLevelFareThreshold, type, level));
          break;
        case 'FOFareClassMapping':
          var fareClassMapping = advancedHepTransformationService.transformFOFareClassMappingPayLoad(row);
          result.updatePayloads.push(buildPayload(fareClassMapping, type, level));
          break;
        case 'FOAnalystPosMapping':
          var analystPosMapping = advancedHepTransformationService.transformFOPosAnalystMapPayload(row);
          result.updatePayloads.push(buildPayload(analystPosMapping, type, level));
          break;
        case 'FOTacticalFareIndex':
          var tacticalFareIndex = advancedHepTransformationService.transformFOTacticalFareIndexPayload(row);
          result.updatePayloads.push(buildPayload(tacticalFareIndex, type, level));
          break;
        case 'FOTacticalUserOverrides':
          var tacticalUserOverrides = advancedHepTransformationService.transformFOTacticalUserOverridesPayload(row);
          result.updatePayloads.push(buildPayload(tacticalUserOverrides, type, level));
          break;
        case 'FOFareBrandAssignment':
          var fareBrandAssignment = advancedHepTransformationService.transformFOFareBrandAssignmentPayload(row);
          result.updatePayloads.push(buildPayload(fareBrandAssignment, type, level));
          break;
        case 'FOTacticalFareDefinition':
          var tacticalFareDefinition = advancedHepTransformationService.transformFOTacticalFareDefinitionPayload(row);
          result.updatePayloads.push(buildPayload(tacticalFareDefinition, type, level));
          break;
        case 'FOTacticalFBCPatternConfig':
          var tacticalFBCPatternConfig = advancedHepTransformationService.transformFOTacticalFBCPatternConfigPayload(row);
          result.updatePayloads.push(buildPayload(tacticalFBCPatternConfig, type, level));
          break;
        case 'DA_FareFloorCeiling':
          var daFareFloorCeilingConfig = advancedHepTransformationService.transformDAFareFloorPayload(row);
          result.updatePayloads.push(buildPayload(daFareFloorCeilingConfig, type, level));
          break;
        case 'FOSurchargeManagement':
          var surchargeManagementConfig = advancedHepTransformationService.convertFOAttributeNameToAttributeName(row);
          result.updatePayloads.push(buildPayload(surchargeManagementConfig, type, level));
          break;
        default:
          result.updatePayloads.push(buildPayload(row, type, level));
          break;
      }
      return result;
    }, {
      updatePayloads: [],
      deletePayloads: []
    });
  }
  function removeAdditionalKeys(row, keys) {
    for (var i = 0; i < keys.length; i++) {
      delete row[keys[i]];
    }
  }
  function consolidateRowsWithSameHepKey(rows, level, type) {
    var map = [];
    var retValue = [];
    _.forEach(rows, function (row) {
      var hepKey = buildHepKey(row, type, level);
      var value = _.isUndefined(map[hepKey]) ? _.cloneDeep(row) : map[hepKey];
      var hostBrandLevelProperty = buildTacticalPropertiesAtFareBrandLevel(row);
      value.foTacticalFareBrandUserOverrideProperties = _.isUndefined(value.foTacticalFareBrandUserOverrideProperties) ? [hostBrandLevelProperty] : _.concat(value.foTacticalFareBrandUserOverrideProperties, hostBrandLevelProperty);
      map[hepKey] = value;
    });
    for (var key in map) {
      var value = map[key];
      retValue = _.concat(retValue, [value]);
    }
    return retValue;
  }
  function buildTacticalPropertiesAtFareBrandLevel(mapValue) {
    var fareBrandLevelProperty = {};
    fareBrandLevelProperty.hostFareBrand = isEmptyString(mapValue.hostFareBrand) ? null : mapValue.hostFareBrand;
    fareBrandLevelProperty.outboundWeekendDefinition = mapValue.outboundWeekendDefinition;
    fareBrandLevelProperty.inboundWeekendDefinition = mapValue.inboundWeekendDefinition;
    fareBrandLevelProperty.advancePurchase = mapValue.advancePurchase;
    fareBrandLevelProperty.timeOfDayPropertiesList = mapValue.timeOfDayPropertiesList;
    fareBrandLevelProperty.proactiveBlackoutPropertiesList = mapValue.proactiveBlackoutPropertiesList;
    fareBrandLevelProperty.seasons = mapValue.foSeasons;
    return fareBrandLevelProperty;
  }
  function isEmptyString(property) {
    if (_.isUndefined(property) || _.isNil(property) || property.length === 0) {
      return true;
    }
    return false;
  }
  function buildFareBrandDefinitionConfigPayload(rows, level, type) {
    var fareBrandDefinitionProperties = _.chain(rows).each(function (row) {
      cleanRow(row);
      cleanEmptyFields(row);
      _.each(row.fareBrands, function (fareBrands) {
        cleanRow(fareBrands);
        cleanEmptyFields(fareBrands);
        fareBrands.fareBrand = fareBrands.fareBrand.toUpperCase();
      });
    }).map(function (row) {
      return removeAttributesFromRowObject(row, level);
    }).value();
    return {
      updatePayloads: [{
        type: type,
        properties: {
          fareBrandDefinitionProperties: fareBrandDefinitionProperties
        }
      }],
      deletePayloads: []
    };
  }
  function buildHepKey(row, type, level) {
    var hepKey = type + '.' + _.chain(level.split('.')).map(function (property) {
      if (_.startsWith(type, 'FO')) {
        if (property === 'cabin') {
          property = 'foCabin';
        }
        if (property === 'carrier') {
          property = 'foCarrier';
        }
      } else if (_.startsWith(type, 'FP') || _.startsWith(type, 'DA')) {
        if (property === 'pos') {
          property = 'daPos';
        }
      }
      return correctValueForDeleting(row, property);
    }).filter(function (e) {
      return !_.isEmpty(e);
    }).join('.').value();
    return '\'' + hepKey + '\'';
  }
  function buildPayLoadForRemoval(row, type, level) {
    return {
      hepKey: buildHepKey(row, type, level),
      type: type
    };
  }
  function buildHepKeys(rows, type, level) {
    return _.reduce(rows, function (result, row) {
      result.push(buildHepKey(row, type, level));
      return result;
    }, []).join(',');
  }
  function buildRemovePayloads(rows, type, level) {
    if (type === 'DA_RIAWeights') {
      return [{
        hepKeys: buildHepKeys(rows, type, level),
        type: type
      }];
    }
    return _.reduce(rows, function (result, row) {
      result.push(buildPayLoadForRemoval(row, type, level));
      if (type === 'FP_MarketConfig') {
        result = _.concat(result, advancedHepTransformationService.getBenchmarkCarriersForDelete(row));
      }
      return result;
    }, []);
  }
  function getLegIdAttributes() {
    return ['origin', 'airlineCode', 'flightNumber', 'departureDate', 'destination'];
  }
  return {
    buildSavePayloads: buildSavePayloads,
    buildRemovePayloads: buildRemovePayloads,
    clearAllNestedRows: clearAllNestedRows,
    getLegIdAttributes: getLegIdAttributes
  };
};
AdvancedHepPayloadService.$inject = ['AdvancedHepTransformationService', 'MomentConstants', 'MomentService', 'ConfigurationParametersAdvancedService'];
module.exports = AdvancedHepPayloadService;